export default __webpack_public_path__ + "static/media/userAdd.305b7f8c.svg";